import { render, staticRenderFns } from "./regNewCharts.component.vue?vue&type=template&id=e140b106&scoped=true&"
import script from "./regNewCharts.component.vue?vue&type=script&lang=js&"
export * from "./regNewCharts.component.vue?vue&type=script&lang=js&"
import style0 from "./regNewCharts.component.vue?vue&type=style&index=0&id=e140b106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e140b106",
  null
  
)

export default component.exports